import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import RestaurantIcon from '@material-ui/icons/Restaurant';
// import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DeckIcon from '@material-ui/icons/Deck';
import AddIcon from '@material-ui/icons/Add';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import {
        Drawer,
        makeStyles,
        List,
        ListItem,
        ListItemText,
        ListItemIcon,
        Divider,
        useTheme,
        Collapse,
        IconButton
            } from '@material-ui/core'
            
            

const useStyle = makeStyles(theme =>({
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: 240,
            flexShrink: 0,
          },
    },
    drawerPaper : {
        width : 240
    },
    nested : {
        paddingLeft: theme.spacing(4),
    },

    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
      },
    cocina : {

    }          
}));



const MenuDrawer = (props) => {
    //PROPS
    const {open, setopen, window} = props;
    const history = useHistory()
    //STATE
    const [openSalon, setopenSalon] = useState(false);
    const [openDelivery, setopenDelivery] = useState(false);
    const [openCarta, setopenCarta] = useState(false);
    const classes = useStyle()
    //HOOKS
    const theme = useTheme();
    //FUNCIONES
    const handleClick = (menu) => {
        switch (menu) {
            case "salon":
                setopenSalon(!openSalon)
                break;
            case "delivery":
                setopenDelivery(!openDelivery)
                break;
            case "carta" :
                setopenCarta(!openCarta)
                break;
            default:
                break;
        }
       
    }
    // const newPedido = () => {
    //    history.push('/admin/new_pedido')
    // }
    const container = window !== undefined ? () => window().document.body : undefined;
    return (  
        <Drawer 
            className ={classes.drawer}
            container = {container}
            variant = 'temporary'
            open={open}
            classes ={{
                paper : classes.drawerPaper
            }}
            anchor = {theme.direction === 'rtl' ? 'right' : 'left'}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
        >
        <div className = {classes.drawerHeader}>
            <IconButton onClick={() => setopen(!open)}>
                {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
        </div>
       
        <List component='nav'>
            
            {/* {ITEM 1} */}
            <Divider />
            {/*<ListItem button onClick={() => handleClick("delivery")}>
                <ListItemIcon>
                    <MotorcycleIcon/>
                </ListItemIcon>
                <ListItemText primary="Delivery" />
                {openDelivery ? <ExpandLess /> : <ExpandMore />}
             </ListItem>
                <Collapse in={openDelivery} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem  onClick={()=>newPedido()} button className={classes.nested}>
                            <ListItemIcon>
                                <AddIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Nuevo Pedido" />
                        </ListItem>
                    </List>
                    
                 
                </Collapse>
                <Divider /> */}
                <ListItem button onClick={() => handleClick("salon")}>
                <ListItemIcon>
                    <RestaurantIcon/>
                </ListItemIcon>
                <ListItemText primary="Salon" />
                {openSalon ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
                <Collapse in={openSalon} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                    <ListItem button className={classes.nested} onClick={()=> history.push('/admin/salon')}>
                            <ListItemIcon>
                                <DeckIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Ver Mesas" />
                        </ListItem>
                    </List>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested} onClick={()=> history.push('/admin/new_pedidoSalon')}>
                            <ListItemIcon>
                                <AddIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Nueva orden" />
                        </ListItem>
                    </List>
                </Collapse>
                {/* ITEM 3 */}
                <Divider />
                <ListItem button onClick={() => handleClick("carta")}>
                <ListItemIcon>
                    <RestaurantMenuIcon/>
                </ListItemIcon>
                <ListItemText primary="Carta" />
                {openCarta ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openCarta} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested} onClick={() => history.push('/admin/ver_carta')}>
                            <ListItemIcon>
                                <MenuBookIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Ver Menu" />
                        </ListItem>
                    </List>
                </Collapse>
                <Divider />
                <ListItem onClick={()=> history.push('/admin/facturacion')} button className={classes.cocina}>
                    <ListItemIcon>
                        <AttachMoneyIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Facturación" />
                </ListItem>
         </List>   
        <Divider />
        </Drawer>
    );
}
 
export default MenuDrawer;